module.exports = __webpack_public_path__ + "assets/fonts/494ec5a3-71df-4fb1-8edc-aac04aaafce2.9d320ea0.woff";